export enum QuestionType {
  CHOOSE_MANY = 'CHOOSE_MANY',
  DATE_IN = 'DATE_IN',
  FILL_IN = 'FILL_IN',
  MULTIPLE = 'MULTIPLE',
  PSYML = 'PSYML',
  RADIO_BUTTON = 'RADIO_BUTTON',
  RADIO_COLOR = 'RADIO_COLOR',
  SELECT_SIMPLE = 'SELECT_SIMPLE',
  TEXTAREA_IN = 'TEXTAREA_IN',
}
